import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import type { Agency } from './agency';

export interface UpdateLoanParams {
  loanId: string;
  metadata?: {
    documentGroupingId: string;
  };
  agency?: Agency | null;
}

export interface UpdateLoanResponse {
  success: boolean;
  message: string;
}

const updateLoan: MutationFunction<
  UpdateLoanResponse,
  UpdateLoanParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateLoanResponse>(
    `/loans/${args.loanId}`,
    {
      method: 'PUT',
      body: {
        ...(args.metadata !== undefined && { metadata: args.metadata }),
        ...(args.agency !== undefined && { agency: args.agency }),
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to update loan');
};

export default updateLoan;

const _mockType: UpdateLoanResponse = {
  success: true,
  message: 'success',
};
